import * as React from "react";

import { SharedTemplateDetailsModal } from "@v1/components/templateLibrary/SharedTemplateDetailsModal";
import EmptyLayout from "@v1/layouts/EmptyLayout";
import { useNavigate } from "react-router-dom";

const ShareTemplateLayout = () => {
  const navigate = useNavigate();
  return (
    <EmptyLayout>
      <SharedTemplateDetailsModal
        onClose={() => {
          navigate("/");
        }}
      />
    </EmptyLayout>
  );
};

export default ShareTemplateLayout;
